import { render } from "./checkbox-input.vue?vue&type=template&id=34a71530&scoped=true"
import script from "./checkbox-input.vue?vue&type=script&lang=js"
export * from "./checkbox-input.vue?vue&type=script&lang=js"

import "./checkbox-input.vue?vue&type=style&index=0&id=34a71530&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a71530"],['__file',"src/views/form/components/checkbox-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34a71530"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34a71530', __exports__)) {
    console.log('reload')
    api.reload('34a71530', __exports__)
  }
  
  module.hot.accept("./checkbox-input.vue?vue&type=template&id=34a71530&scoped=true", () => {
    console.log('re-render')
    api.rerender('34a71530', render)
  })

}


export default __exports__